/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CompanyQuestionModelWithListSerializerNumberQuestionType = {
  readonly id?: number;
  name: string;
  question_type: CompanyQuestionModelWithListSerializerNumberQuestionType.question_type;
  options?: Array<number>;
  company?: number;
  description?: string | null;
  new_options?: Array<string>;
};
export namespace CompanyQuestionModelWithListSerializerNumberQuestionType {
  export enum question_type {
    '_0' = 0,
    '_1' = 1,
    '_2' = 2,
    '_3' = 3,
  }
}
